(() => {
  const TRIGGER_VARIANT = 55285180367175; // Abo 1 an
  const GIFT_VARIANT = 55285086323015;    // Artbook Assassin's Creed
  const PROP = '_jvm_gift';               // marque l'artbook ajouté automatiquement
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  // Masque les badges de réduction à 0,00 € (ligne dont le prix n'est pas réduit, ex. l'abonnement déclencheur)
  const style = document.createElement('style');
  style.textContent = '.price:not(.price--on-sale) + .discounts { display: none !important; }';
  document.head.appendChild(style);

  let running = false, again = false, pending = Promise.resolve(), addFailed = false;

  const post = (path, body) =>
    nativeFetch(root + path, { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify(body) });

  function sections() {
    const list = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: list } })
    );
    return [...new Set(list)].slice(0, 5);
  }

  function render(cart) {
    if (typeof theme !== 'undefined' && theme.pubsub && document.querySelector('cart-items')) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'jvm-gift', cart });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    }
  }

  async function syncOnce() {
    const cart = await (await nativeFetch(root + 'cart.js', { headers: json, credentials: 'same-origin' })).json();
    const hasTrigger = cart.items.some((i) => i.variant_id === TRIGGER_VARIANT);
    const gifts = cart.items.filter((i) => i.variant_id === GIFT_VARIANT && i.properties && i.properties[PROP]);
    let res;

    if (!hasTrigger) addFailed = false;

    if (hasTrigger && gifts.length === 0) {
      if (addFailed) return; // rupture de stock, etc. : pas de boucle
      const add = await post('cart/add.js', {
        items: [{ id: GIFT_VARIANT, quantity: 1, properties: { [PROP]: 'abo-1-an' } }],
      });
      if (!add.ok) { addFailed = true; return; }
      res = await post('cart/update.js', { sections: sections() });
    } else if (!hasTrigger && gifts.length > 0) {
      const updates = {};
      gifts.forEach((g) => (updates[g.key] = 0));
      res = await post('cart/update.js', { updates, sections: sections() });
    } else if (hasTrigger && (gifts.length > 1 || gifts[0].quantity !== 1)) {
      const updates = {};
      gifts.forEach((g, n) => (updates[g.key] = n === 0 ? 1 : 0));
      res = await post('cart/update.js', { updates, sections: sections() });
    } else {
      return; // panier déjà cohérent
    }
    if (res && res.ok) render(await res.json());
  }

  function sync() {
    if (running) { again = true; return pending; }
    running = true;
    pending = (async () => {
      try { do { again = false; await syncOnce(); } while (again); }
      catch (e) { console.error('[jvm-gift]', e); }
      finally { running = false; }
    })();
    return pending;
  }

  // 1. Toute modification du panier faite par le thème
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(sync, () => {});
    return p;
  };

  // 2. Chargement de page (panier en page, retour arrière, etc.)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  window.addEventListener('pageshow', (e) => { if (e.persisted) sync(); });

  // 3. Paiement : attendre la synchronisation avant de partir
  let bypass = false;
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el || bypass) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    sync().then(() => { bypass = true; el.click(); bypass = false; });
  }, true);
})();
